import {SearchToSelect} from "../../../components";
import React, {Component} from "react";
import PropTypes from "prop-types";
import {searchCredentials} from "./credentialApi";

export default class CredentialSelector extends Component {

    static propTypes = {
        selected: PropTypes.any,
        onSelected: PropTypes.func,
        placeholder: PropTypes.string,
        provider: PropTypes.array
    }

    static getSearchResults({
        nameSearch, provider, offset
    }) {
        return searchCredentials({
            nameSearch, provider, offset, includeHasMore: true, limit: 6
        }).then(({ results, hasMore }) => {
            return ({ items: results.map(result => result.credential), hasMore: hasMore })
        });
    }

    render() {
        return <SearchToSelect
            {...this.props}
            getSearchResults={(params) => {
                return CredentialSelector.getSearchResults({provider: this.props.provider, nameSearch: params.query, offset: params.offset})
            }}
            getKey={googleAccount => googleAccount.id}
            renderOption={credential => credential.remoteAccountName}
        />
    }
}